// A picture of high-end veneer for the Wood TV: quarter-sawn, so the grain is fine, straight and even, with a soft ribbon of lighter and darker stripes (the way a
// walnut or mahogany veneer looks on good furniture), a few quiet figured patches, and very faint pores. The grain runs left to right. It is drawn once with the
// canvas (no picture file to download) and used both by the page (the front of the TV) and by the 3-D body (the sheet wrapped around it), so the two match.
//
// opts.edges: draw a thin dark line down the left and right edge (the two ends of a sheet that is wrapped around the TV meet there, and that is the seam)

export function plywoodCanvas(w, h, seed = 7, opts = {}) {
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const g = c.getContext("2d");
  let s = seed * 9301 + 49297; const rnd = () => { s = (s * 16807) % 2147483647; return s / 2147483647; };
  const area = (w * h) / (640 * 704);

  // the base: a warm, fairly dark walnut
  g.fillStyle = "#a8703f"; g.fillRect(0, 0, w, h);
  // ribbon stripes: soft bands of lighter and darker wood that run the length of the sheet, as in quarter-sawn veneer
  let y = -h * 0.05;
  while (y < h) {
    const bh = h * (0.025 + rnd() * 0.07), light = rnd() < 0.5;
    const gr = g.createLinearGradient(0, y, 0, y + bh);
    const a = 0.05 + rnd() * 0.09, col = light ? "255,214,160" : "58,26,8";
    gr.addColorStop(0, `rgba(${col},0)`); gr.addColorStop(0.5, `rgba(${col},${a})`); gr.addColorStop(1, `rgba(${col},0)`);
    g.fillStyle = gr; g.fillRect(0, y, w, bh); y += bh * (0.55 + rnd() * 0.5);
  }
  // fine, straight grain: many thin lines that hardly wave
  const lines = Math.round(520 * area + 120);
  for (let i = 0; i < lines; i++) {
    const y0 = rnd() * h, amp = (0.15 + rnd() * 0.9) * (h / 704), f1 = (1 + rnd() * 2) * Math.PI / w, p1 = rnd() * 6.28, dark = rnd() < 0.7;
    g.strokeStyle = dark ? `rgba(62,28,8,${(0.04 + rnd() * 0.13).toFixed(3)})` : `rgba(255,222,170,${(0.03 + rnd() * 0.08).toFixed(3)})`;
    g.lineWidth = (0.4 + rnd() * 0.9) * Math.max(0.7, h / 704);
    g.beginPath();
    for (let x = 0; x <= w; x += 16) {
      const yy = y0 + Math.sin(x * f1 + p1) * amp * 2;
      if (x === 0) g.moveTo(x, yy); else g.lineTo(x, yy);
    }
    g.stroke();
  }
  // a couple of quiet, wide figured patches (very faint, long and low)
  for (let i = 0; i < 2; i++) {
    const cx = rnd() * w, cy = rnd() * h, rx = w * (0.3 + rnd() * 0.4), ry = h * (0.015 + rnd() * 0.025);
    for (let k = 1; k <= 9; k++) {
      g.strokeStyle = `rgba(70,32,10,${(0.03 + rnd() * 0.04).toFixed(3)})`; g.lineWidth = 0.6 + rnd() * 0.6;
      g.beginPath(); g.ellipse(cx, cy, rx * k / 9, ry * k / 9, 0, Math.PI, Math.PI * 2); g.stroke();
    }
  }
  // pores: very faint short dashes
  g.fillStyle = "rgba(50,22,6,.14)";
  for (let i = 0; i < Math.round(420 * area); i++) g.fillRect(rnd() * w, rnd() * h, 2 + rnd() * 6, 0.7);
  if (opts.edges) {
    g.fillStyle = "rgba(24,10,2,.8)";
    const e = Math.max(2, Math.round(w / 500));
    g.fillRect(0, 0, e, h); g.fillRect(w - e, 0, e, h);
  }
  return c;
}

export const plywoodDataUrl = (w, h, seed) => plywoodCanvas(w, h, seed).toDataURL("image/jpeg", 0.86);
